<template>
  <TheBaseGrid :showEditor="true" editorHeader="Eksempel" editorHeight="136px" @next="checkInput">
    <template slot="intro">
      <h2>CSS Syntax</h2>
      <p>Et CSS-regelsæt består af en selector og en deklarationsblok</p>
      <p>Selector peger på det HTML-element, du vil style.<br>
      Erklæringsblokken indeholder en eller flere erklæringer adskilt af semikoloner. Hver erklæring indeholder et CSS-property og en værdi, adskilt af et kolon.

En CSS-erklæring slutter altid med et semikolon, og erklæringsklodser er omgivet af curly brackets "{}".</p>
<p>Herunder et eksempel: "h1" er selector "color" er property og "red" er værdien.</p>
    </template>
    <template slot="cssInput">
      <pre class="before">h1 {
  {{cssInput}}</pre><pre class="after">}</pre>
    </template>

    <template slot="output">
      <h1 :style="cssInput">Hello world</h1>
    </template>

  </TheBaseGrid>
</template>

<script>
import TheBaseGrid from '@/components/TheBaseGrid.vue'
export default {
  name: 'episode0',
  data () {
    return {
      cssInput: `color:red;`
    }
  },
  components: {
    TheBaseGrid
  },
  computed: {
  },
  methods: {
    checkInput(){
      this.$router.push({ path: '/season/1/episode/1' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
